import { useRef, useState } from "react";

const VideoPlayer = ({ src, width }) => {
  const videoRef = useRef(null);
  const controlsTimeout = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showControls, setShowControls] = useState(true);

  //  Time states
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const isYouTube =
  src.includes("youtube.com") || src.includes("youtu.be");

  // Convert YouTube link into embed format
  const getYouTubeEmbed = (link) => {
    let videoId = "";

    if (link.includes("youtu.be/")) {
      videoId = link.split("youtu.be/")[1].split("?")[0];
    } else if (link.includes("watch?v=")) {
      videoId = link.split("watch?v=")[1].split("&")[0];
    }

    return `https://www.youtube.com/embed/${videoId}`;
  };
  
  //  Format time into MM:SS
  const formatTime = (time) => {
    if (time === null || time === undefined || isNaN(time)) return "0:00";

    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);

    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    };

  //  Play / Pause Toggle
  const togglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.pause();
    } else {
      video.play();
    }

    setIsPlaying(!isPlaying);
  };

  //  Get duration once video loads
  const handleLoadedMetadata = () => {
    const video = videoRef.current;
    if (!video) return;

    setDuration(video.duration);
  };

  //  Update current time + progress bar
  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (!video) return;

    setCurrentTime(video.currentTime);

    const percent = (video.currentTime / video.duration) * 100;
    setProgress(percent);
  };

  //  Seek video when user drags slider
  const handleSeek = (e) => {
    const video = videoRef.current;
    if (!video) return;

    const newTime = (e.target.value / 100) * video.duration;
    video.currentTime = newTime;

    setProgress(e.target.value);
    setCurrentTime(newTime);
  };

  // display and hide controls
  const handleMouseMove = () => {
    setShowControls(true);

    // Clear old timeout
    if (controlsTimeout.current) {
        clearTimeout(controlsTimeout.current);
    }

    // Hide controls after 2 seconds
    controlsTimeout.current = setTimeout(() => {
        setShowControls(false);
    }, 2000);
    };

  return (
    <div
      onMouseMove={handleMouseMove}
     className={` w-full max-w-none rounded-xl overflow-hidden shadow-lg relative`} style={{ width: width }}>
      {/* Video */}
      {isYouTube ? (
        <iframe
          src={getYouTubeEmbed(src)}
          title="YouTube Video"
          className="w-full aspect-video"
          allowFullScreen
        />
      ) : (
        <video
          ref={videoRef}
          onLoadedMetadata={handleLoadedMetadata}
          onTimeUpdate={handleTimeUpdate}
          className="w-full"
        >
          <source src={src} type="video/mp4" />
        </video>
      )}

      {/* Custom Controls */}
      
      {!isYouTube && (

        <>
        {/* Play Button */}
        <button
          onClick={togglePlay}
          className={`bg-[#D10909] hover:bg-purple-700 absolute bottom-1/2 left-1/2 translate-y-1/2 transform -translate-x-1/2 w-20 h-20 rounded-full flex justify-center items-center
          transition-opacity duration-500
    ${showControls ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          {isPlaying ?
           <div className="flex gap-2">
            <div className="w-2 h-6 bg-white"></div>
            <div className="w-2 h-6 bg-white"></div>
        </div>
          : 
          <div className="w-0 h-0
                border-t-[12px] border-t-transparent
                border-b-[12px] border-b-transparent
                border-l-[20px] border-l-white">
            </div> 
          }
        </button>

        {/* Progress Bar */}
        <div className={`absolute bottom-4 left-1/2 translate-y-1/2 transform -translate-x-1/2 flex flex-col  justify-center items-center w-full p-2 ${showControls ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            
            <div className="w-full flex justify-between">

                {/* mini play/pause button */}
                <button
                onClick={togglePlay}
                className="w-5 flex justify-center items-center bg-transparent"
                >
                {isPlaying ?
                 <div className="flex gap-0.5">
                    <div className="w-1 h-3 bg-white"></div>
                    <div className="w-1 h-3 bg-white"></div>
                </div>
                : 
                <div className="w-0 h-0
                    border-t-[8px] border-t-transparent
                    border-b-[8px] border-b-transparent
                    border-l-[12px] border-l-white">
                </div>
                }
                </button>

                {/* progress bar */}
                <input
                type="range"
                value={progress}
                onChange={handleSeek}
                className="w-[95%] accent-white"
                />
            </div>

            <div className="w-full flex flex-row justify-between text-white">
            <p>{formatTime(currentTime)}</p>
            <p>{formatTime(duration)}</p>
            </div>
        </div>
        </>
        )}
      
    </div>
  );
};

export default VideoPlayer;
